module.exports = __webpack_public_path__ + "static/media/buildingConstruction32.bf86060d.jpg";